// extracted by mini-css-extract-plugin
module.exports = {"overview_2o8OGT":"overview_2o8OGT","data-table_2PMMk9":"data-table_2PMMk9","anypoint-icon":"anypoint-icon"};